import { TRACKING } from "@/config/tracking";

const consented = () => {
  try { return localStorage.getItem("empire_cookie_consent") === "accepted"; } catch { return false; }
};

const ready = () => Boolean(TRACKING.GOOGLE_ADS_ID) && consented() && typeof window.gtag === "function";

const fireConversion = (label, params = {}) => {
  if (!label || !ready()) return;
  window.gtag("event", "conversion", { send_to: `${TRACKING.GOOGLE_ADS_ID}/${label}`, ...params });
};

export const fireQuoteConversion = () => fireConversion(TRACKING.GADS_QUOTE_LABEL, { value: 1.0, currency: "GBP" });
export const fireContactConversion = () => fireConversion(TRACKING.GADS_CONTACT_LABEL);

export const initContactClickTracking = () => {
  if (window.__gadsClicksBound) return;
  window.__gadsClicksBound = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"], a[href*="wa.me/"]');
      if (a) fireContactConversion();
    },
    true
  );
};
